import { timelineSteps } from '@/mocks/gossip';
import SectionHeading from '@/pages/home/components/SectionHeading';

export default function TimelineSection() {
  return (
    <section id="timeline" className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="TIMELINE · 吃瓜时间线"
          title="吃瓜时间线 · 一条爆料是如何发酵的"
          desc="以「塌房风暴」这一类事件为例，还原一条爆料从出现到回落的完整节奏。理解传播路径，才能更冷静地看待每一次热搜。"
        />

        <div className="relative max-w-3xl mx-auto pl-8 md:pl-12">
          <span
            className="absolute left-[11px] md:left-[19px] top-2 bottom-2 w-px bg-background-300"
            aria-hidden="true"
          ></span>

          <ol className="flex flex-col gap-6 md:gap-8">
            {timelineSteps.map((step, index) => {
              const highlight = index === 2 || index === 3;
              return (
                <li key={step.id} className="relative">
                  <span
                    className={`absolute -left-8 md:-left-12 top-1 w-6 h-6 rounded-full flex items-center justify-center text-[11px] font-label ${
                      highlight
                        ? 'bg-accent-500 text-foreground-950'
                        : 'bg-background-100 border border-background-300 text-foreground-600'
                    }`}
                    aria-hidden="true"
                  >
                    {index + 1}
                  </span>
                  <div className="rounded-lg bg-background-100 border border-background-200 p-4 md:p-5">
                    <span className="inline-block text-xs font-label text-primary-600 mb-1.5">{step.time}</span>
                    <h3 className="font-heading text-lg md:text-xl text-foreground-950 leading-snug mb-2">
                      {step.title}
                    </h3>
                    <p className="text-sm text-foreground-600 leading-relaxed font-body">{step.desc}</p>
                  </div>
                </li>
              );
            })}
          </ol>
        </div>
      </div>
    </section>
  );
}